import React from "react";
import { ReactComponent as Bottom } from "./bg_bottom.svg";

export default function Footer() {
  return (
    <React.Fragment>
      {/* <div id="footer">
       */}
      <div>
        <p
          style={{
            display: "inline-block",
            verticalAlign: "bottom",
            lineHeight: 1.5,
          }}
        >
          Copyright © 2023 BeccoCRO Inc. <br /> All trademarks or registered
          trademarks are property of their respective owners.
        </p>
      </div>
    </React.Fragment>
  );
}
